import { AuthUserPermission, Can } from '@cibo/profile'
import AddIcon from '@mui/icons-material/Add'
import { Button, Stack, Typography } from '@mui/material'
import Image from 'mui-image'
import { useTranslation } from 'react-i18next'
import { Link as RRLink } from 'react-router-dom'
import { SCOPE_THREE_ROUTES } from '../../../../navigation/types/scopeThreeRoutes'
import imgUrl from './empty-state.jpg'

export const NoInventories = () => {
  const { t } = useTranslation('impact/NoInventories')
  return (
    <Stack alignItems="center" mt={8} data-testid="no-inventories">
      <Stack spacing={3} sx={{ maxWidth: '300px' }} alignItems="center">
        <Image src={imgUrl} style={{ width: '300px', height: '300px', borderRadius: '50%' }} />
        <Typography textAlign="center" variant="h5">
          {t('header')}
        </Typography>
        <Can useAny={AuthUserPermission.SCOPE3_INVENTORY_CREATE}>
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            component={RRLink}
            to={SCOPE_THREE_ROUTES.CREATE}
            data-testid="newInventoryBtn"
          >
            {t('cta')}
          </Button>
        </Can>
      </Stack>
    </Stack>
  )
}
